export default function ZButton({
  variant = "primary",
  block = false,
  size = "md",
  loading = false,
  children,
  className = "",
  disabled,
  ...props
}) {
  const variants = {
    primary: "z-btn z-btn-primary",
    teal: "z-btn z-btn-teal",
    outline: "z-btn z-btn-outline",
    ghost: "z-btn z-btn-ghost",
    danger: "z-btn z-btn-danger",
  };
  const cls = [
    variants[variant] || variants.primary,
    block ? "z-btn-block" : "",
    size === "sm" ? "z-btn-sm" : "",
    className,
  ].filter(Boolean).join(" ");
  return (
    <button className={cls} disabled={disabled || loading} {...props}>
      {loading ? <span className={variant === "outline" || variant === "ghost" ? "z-loader z-loader-dark" : "z-loader"} /> : children}
    </button>
  );
}
